import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import classnames from 'classnames';
import './style.scss';

import {MainGrid} from 'components/atoms/Layout/MainGrid';
import {UserAgent} from 'components/atoms/UserAgent';
import {Direction, NavArrow} from '@atoms/LinksAndButtons/NavArrow';
import {useScrollListener} from "components/hooks/useScrollListener";

interface Props {
    logoMargin?: boolean;
    children?: React.ReactNode;
    button?: React.ReactNode;
}

export const ImageHeaderMenu: React.FunctionComponent<Props> = ({
    logoMargin,
    children, button
}) => {

    const {scrollingUp} = useScrollListener();

    const pageMenuRef = useRef<HTMLDivElement>(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);

    const scrollAmount = 150; // Hur långt varje klick ska scrolla

    const updateButtons = () => {
        if (pageMenuRef.current) {
            setCanScrollLeft(pageMenuRef.current.scrollLeft > 0);
            setCanScrollRight(pageMenuRef.current.scrollLeft < pageMenuRef.current.scrollWidth - pageMenuRef.current.clientWidth);
        }
    };

    useEffect(() => {
        updateButtons();
        const menu = pageMenuRef.current;
        if (menu) {
            menu.addEventListener("scroll", updateButtons);
            return () => menu.removeEventListener("scroll", updateButtons);
        }
        return () => {};
    }, [children]);

    const scroll = (direction: "left" | "right") => {
        if (pageMenuRef.current) {
            pageMenuRef.current.scrollBy({
                left: direction === "left" ? -scrollAmount : scrollAmount,
                behavior: "smooth",
            });
        }
    };

    const headerClasses = classnames('image-header-menu', {
        'image-header-menu--sticky': scrollingUp,
        'image-header-menu--logo-margin': logoMargin,
        'image-header-menu--scroll-left': canScrollLeft,
        'image-header-menu--scroll-right': canScrollRight,
    });

    return (
        <div className={headerClasses}>
            <div className="image-header-menu__wrapper">
                <MainGrid fullwidth>
                    <div className="image-header-menu__container" data-test-id="image-header-menu-container">
                        {canScrollLeft && (
                            <NavArrow
                                direction={Direction.PREV}
                                small
                                onClick={() => scroll("left")}
                            />
                        )}
                        <div className="image-header-menu__nav" ref={pageMenuRef}>
                            <ul>
                                {children}
                            </ul>
                        </div>
                        {canScrollRight && (
                            <NavArrow
                                direction={Direction.NEXT}
                                small
                                onClick={() => scroll("right")}
                            />
                        )}
                        {button &&
                            <UserAgent computer>
                                <div className="image-header-menu__action">
                                    {button}
                                </div>
                            </UserAgent>
                        }
                    </div>
                </MainGrid>
            </div>
        </div>
    )
};
